import React, { useEffect } from "react";
import { delay } from "lodash";
import queryString from 'query-string';
import { withRouter } from "react-router-dom";
import Preloader from "../CommonComponents/Preloader/Preloader";
import { getFromSessionStorage } from '../utils/sessionUtil';
import PropTypes from 'prop-types';

const othertranscationPath = (type, transactionId) => {
  switch (type) {
    case "From TIFF":
      return { pathname: `/view-edit-tiff-from/${transactionId}/view` };
    case "To TIFF":
      return { pathname: `/view-edit-tiff-into/${transactionId}/view` };
    case "Reallocation":
    case "Custom exchange":
      return {
        pathname: `/investments/recommend-an-exchange/${transactionId}/view`,
        search: `type=onetime`
      };
    default:
      return {
        pathname: "/my-account/other-transaction",
        state: { transactionId, redirectFromGemini: true }
      };
    }
};

const navigateToProperPath = () => {
  let accData = JSON.parse(getFromSessionStorage('userData'));
  const { financialAdvisorForAnyAccount } = accData;
  return financialAdvisorForAnyAccount ? '/financialadvisor' : '/'
}

const setRedirectPage = (pageName, props) => {
  let path;  
  const { grantId, scheduleId, workflowId, transactionId, type } = queryString.parse(props.location.search);
    
  switch(pageName) {
    case 'accountSummary': path = navigateToProperPath(); break;
    case 'accountDetails': path = '/my-account'; break;
    case 'transactionSummary': path = '/my-account/transaction-summary'; break;
    case 'recommendExchange': path = '/investments/recommend-an-exchange'; break;
    case 'viewContributionDetailsForPortal': path = { pathname: '/contributions/activity/view', state: { transactionId: workflowId } }; break;
    case 'grantRecommendationConfirmation': path = { pathname: '/grants/recommend/confirm', search: queryString.stringify({ grantId, scheduleId }) }; break;
    case 'viewOtherTranscationDetails':  path = othertranscationPath(type, transactionId); break;
    default: path='/';
  }
  return delay(()=>{ props.history.push(path) });
}

const CsrMainComponent = (props) => {  
  const { pageName } = props.match.params;

  useEffect(()=> {
    setRedirectPage(pageName, props);
  }, []); 

	return(<Preloader data-test="csrMainPreloader"/>);
}

CsrMainComponent.propTypes = {
  history: PropTypes.any,
  location: PropTypes.shape({
    search: PropTypes.any
  }),
  match: PropTypes.shape({
    params: PropTypes.any
  })  
}

export default withRouter(CsrMainComponent);
